import { message } from "antd";
import { Col, Container, Row } from "react-grid-system";
import Emoji from "./components/Emoji";


interface SuccessProps {
    messageApi: ReturnType<typeof message.useMessage>[0];
}

function Success(props: SuccessProps) {
    return (
        <Container style={{ marginTop: "32px" }}>
            <Row gutterWidth={20} justify="center">
                <Col sm={8} md={6}>
                    <div style={{ backgroundColor: "#5CCABA", borderRadius: "10px", padding: "20px", color: "white" }}>
                        <h1 className="text-2xl md:text-4xl font-black pb-2" style={{ color: "white" }}><Emoji symbol="&#127881;" label="" /> Booking successful!</h1>
                        <p>You should shortly receive a confirmation email with payment information.</p>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default Success;